<template>
  <div>
    <div class="fixBg">
      <div class="pxindBox">
        <div id="qrcode"></div>
        <img
          @click="closeRemindBox"
          class="closepxind"
          src="@/assets/img/loginImg/closeRemind.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { urlScheme } from '@/api/businessOrder';
import loadJS from 'load-js';

export default {
  data() {
    return {};
  },
  components: {},
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {
    courseInfo(data) {
      if (data?.productId) {
        this.getMini();
      }
    },
  },
  created() {},

  mounted() {
    loadJS([
      {
        async: false,
        url: 'https://image-prod.iqihang.com/public/js/qrcode.min.js',
      },
    ]).then(() => {
      this.getMini();
    });
  },
  activated() {},
  methods: {
    async getMini() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const params = {
        appid: 'wxdb89cfa2bb60f779',
        envVersion: 'trial', // trial  release
        path: 'subPackages/openNotice/index',
        query: `type=2&businessId=${this.courseInfo?.productId}`,
      };
      const { code, data } = await urlScheme(params);
      if (code) return;
      this.handleUrl(data);
    },
    handleUrl(url) {
      new QRCode(document.getElementById('qrcode'), {
        text: url,
        render: 'table',
        // render:"canvas",
        width: 80,
        height: 80,
        typeNumber: -1, // 计算模式
        correctLevel: 0, // 纠错等级   correctLevel
      });
      this.$toast.clear();
    },
    closeRemindBox() {
      this.$emit('closeRemindBox');
    },
  },
};
</script>
<style lang="scss" scoped>
.fixBg {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 200;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}
.pxindBox {
  position: absolute;
  top: 22%;
  right: 0;
  left: 0;
  width: 636px;
  height: 872px;
  margin: 0 auto;
  background: url('../../assets/img/loginImg/remind1.png') no-repeat;
  background-size: 100%;
}
#qrcode {
  width: 212px;
  height: 212px;
  margin: 216px 0 0 78px;
  ::v-deep img {
        width: 100%;
  height: 100%;
    }
}

.closepxind {
  position: absolute;
  right: 0;
  bottom: -100px;
  left: 0;
  width: 58px;
  height: 58px;
  margin: 0 auto;
}
</style>
